// Shared `data-tour` attribute KEYS used by BOTH the GuidedTour step builder and
// the components that render the attributes (Header, Dashboard). Keeping the keys
// in one place keeps them DRY and typo-proof: a step selector is always
// `[data-tour="${TOUR.X}"]` and the matching element renders `data-tour={TOUR.X}`.
export const TOUR = {
  HEADER_ACTIONABLES: 'header-actionables',
  HEADER_USER_MENU: 'header-user-menu',
  // Per-CARD anchors — the tour walks each card individually (not whole sections).
  // Daily Workflow
  CARD_ADD_BUNDLE: 'card-add-bundle',
  CARD_REDUCE_BUNDLE: 'card-reduce-bundle',
  CARD_CARDING: 'card-carding',
  CARD_CYCLIC_COUNT: 'card-cyclic-count',
  // Catalog
  CARD_BUNDLE_SKUS: 'card-bundle-skus',
  CARD_BUNDLE_COMBINATION: 'card-bundle-combination',
  CARD_VIEW_INVENTORY: 'card-view-inventory',
  CARD_SAVED_DRAFTS: 'card-saved-drafts',
  CARD_RECENT_ACTIVITIES: 'card-recent-activities',
  CARD_IMAGE_GEN: 'card-image-generation',
  // Admin
  CARD_MANAGE_USERS: 'card-manage-users',
  CARD_SYSTEM_SETTINGS: 'card-system-settings',
} as const;

export type TourKey = (typeof TOUR)[keyof typeof TOUR];
